import { useEffect, useRef, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TableCard } from "../../../../component/table/table-layout";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import Style from "./style.module.css";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  KPI,
  TitleHeading,
} from "../../../../component/ui/layout";
import {
  FeildWraper,
  FormCheckbox,
} from "../../../../component/form/form-layout";
import moment from "moment";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import {
  AlertTriangle,
  Calendar,
  CalendarIcon,
  CheckCircle,
  CircleDollarSign,
  DollarSign,
  History,
  Paperclip,
  Percent,
  RotateCcw,
  ShieldCheck,
  ShieldX,
  TrendingUp,
  UserMinus,
  UserX,
} from "lucide-react";
import RefundList from "./list";
import KpisPopup from "./kpis-popup";
import { useNavigate } from "react-router";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import Tooltip from "../../../../component/ui/tooltip";
import PlusIcon from "../../../../component/icons/plus";
import RefundForm from "../../refundForm";
import { Alert, Snackbar } from "@mui/material";

export default function OrgRefundOverviewOld() {
  const apiCall = useApiCall();
  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false);
  const [isTrendLoad, setIsTrendLoad] = useState(false);
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(
    moment(new Date()).format("YYYY-MM")
  );
  const [activeChart, setActiveChart] = useState("Refunded Amount");
  const [allTime, setAllTime] = useState(false);
  const [allTimeLoader, setAllTimeLoader] = useState(false);
  const [kpiData, setKpiData] = useState({});
  const [apiData, setApiData] = useState({});
  const [sourceData, setSourceData] = useState([]);


  const [trendAllTime, setTrendAllTime] = useState(false);


  const [showRefund, setShowRefund] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [showWorkForce, setShowWorkForce] = useState(false);
  const [popupData, setPopupData] = useState({});

  const [selMonth, setSelMonth] = useState({});

  const [filterType, setFilterType] = useState("month");
  // month | all_time | range

  const [rangeType, setRangeType] = useState(null);
  // last_month | this_year | last_year | this_quater

  const [stEnDates, setStEnDates] = useState({});

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);

    try {
      let params = "";

      if (filterType === "all_time") {
        params = "all_time=1";
      } else if (filterType === "month") {
        params = `year_month=${selectedMonth}`;
      } else if (filterType === "range" && rangeType) {
        params = `range=${rangeType}`;
      }

      const resp = await apiCall({
        method: "get",
        url: `reports/dashboard?${params}`,
      });

      console.log("Source ", resp?.data?.types_data);

      setDashboardData(resp);
      setKpiData(resp?.data);
      setSelMonth(resp?.month);
      setApiData(resp?.data?.qa_status_report);
      setIsDashboardApiLoaded(true);
      setSourceData(resp?.data?.types_data);
      setStEnDates({
        start_date: resp?.start_date,
        end_date: resp?.end_date,
      });
    } catch (error) {
      console.warn(error);
    }
  };

  const route = useNavigate();

  console.log(activeChart);
  //   try {
  //     const resp = await apiCall({ method: "get", url: `get-monthly-water-tanker-trends?type=chart` });
  //     setMonthlyTrend(resp.data);
  //     setIsTrendLoad(true);
  //   } catch (error) {
  //     console.log("Err", error)
  //   }
  // }

  // useEffect(() => {
  //   getMonthlyTrend();
  // }, []);

  useEffect(() => {
    getDashboardData();
  }, [filterType, rangeType, selectedMonth]);

  const parseAmount = (value = "PKR 0.00") =>
    Number(value.replace("PKR ", "").replaceAll(",", ""));

  const rawData = monthlyTrend; // API response

  const dynamicKeys = Object.keys(rawData?.[0] || {}).filter(
    (key) => key !== "month"
  );

  // LINE CHART
  const [trendData, setTrendData] = useState([]);
  const [trendLoading, setTrendLoading] = useState(false);

  const [selectedMonths, setSelectedMonths] = useState(12);
  const [months, setMonths] = useState([]);
  const [fullMonthlyData, setFullMonthlyData] = useState([]);

  const getTrendData = async () => {
    setTrendLoading(true);
    try {
      // Decide API call only for "all" or first monthly load
      const shouldCallAPI =
        selectedMonths === "all" || fullMonthlyData.length === 0;

      let resData;

      if (shouldCallAPI) {
        const url =
          selectedMonths === "all"
            ? "reports/yearly-trends"
            : "reports/monthly-trends";

        const res = await apiCall({ method: "get", url });
        resData = res.data;

        if (selectedMonths !== "all") {
          // cache monthly data
          setFullMonthlyData(resData);
        }
      } else {
        // use cached monthly data
        resData = fullMonthlyData;
      }

      if (selectedMonths === "all") {
        // Yearly data
        const firstYear = Object.keys(resData)[0];
        const monthsArray = resData[firstYear].map(d => d.month);
        setMonths(monthsArray);

        const series = Object.keys(resData)
          .sort((a, b) => b - a) // newest year first
          .map(year => ({
            name: year,
            data: resData[year].map(d =>
              Number(d.total_loss_amount.replaceAll("$", "").replaceAll(",", ""))
            ),
          }));
        setTrendData(series);
      } else {
        // Monthly data (slice locally)
        const filteredData =
          selectedMonths === "all"
            ? resData
            : resData.slice(-selectedMonths);

        setMonths(filteredData.map(d => d.month));
        setTrendData([
          {
            name: "Loss Revenue",
            data: filteredData.map(d =>
              Number(d.total_loss_amount.replaceAll("$", "").replaceAll(",", ""))
            ),
          },
        ]);
      }
    } catch (error) {
      console.warn("Error fetching trend data:", error);
    } finally {
      setTrendLoading(false);
    }
  };

  // console.log("trendData", trendData)


  const lineOptions = {
    chart: { type: "line", backgroundColor: "transparent", height: 300 },
    title: { text: "" },
    xAxis: {
      categories: months, // use months state
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      title: { text: "Loss Revenue" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    legend: {
      enabled: true,
      align: "right",        // horizontal alignment
      verticalAlign: "top",  // vertical alignment
      // layout: "vertical",    // stack series vertically
    },
    series: trendData,
    credits: { enabled: false },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        return this.points
          .map(p => `<span style="color:${p.color}">${p.series.name}: ${p.y}</span>`)
          .join("<br/>");
      },
    },
  };



  useEffect(() => {
    getTrendData();
    // getLeadsBySourceData()
  }, [selectedMonths]);

  // DONUT CHART - Leads by Source
  const USE_DUMMY_DATA = true;
  const [sourceLoading, setSourceLoading] = useState(false);

  // const getLeadsBySourceData = async () => {
  //   setSourceLoading(false);
  //   try {
  //     if (USE_DUMMY_DATA) {
  //       const dummy = [
  //         { source: "Total Lost", count: 20 },
  //         { source: "Total Refund", count: 15 },
  //         { source: "Charge Back", count: 10 },
  //         { source: "Sales Blame", count: 9 },
  //         // { source: "Customer Blame", count: 9 },
  //       ];
  //       setSourceData(dummy);
  //     } else {
  //       const res = await apiCall({ method: "get", url: "leads/dashboard/by-source" });
  //       setSourceData(res?.sources);
  //     }
  //   } catch (error) {
  //     console.warn("Error fetching leads by source:", error);
  //   } finally {
  //     setSourceLoading(true);
  //   }
  // };

  const sourceOptions = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 320,
      spacing: [20, 0, 20, 0],
    },
    title: null,
    credits: { enabled: false },
    tooltip: {
      pointFormat: "<b>${point.y}</b> <br/>({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        innerSize: "65%",
        borderWidth: 2,
        borderColor: "#fff",
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          distance: 15,
          style: { color: "#374151", fontSize: "12px" },
          format: "{point.name}: {point.percentage:.1f}%",
          filter: { property: "percentage", operator: ">", value: 2 },
        },
        showInLegend: true,
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: { color: "#6B7280", fontSize: "12px" },
    },
    series: [
      {
        name: "Refund",
        colorByPoint: false, // disable auto colors
        data: sourceData?.map((el) => ({
          name: el?.type,
          y: el?.amount,
          color: (() => {
            switch (el?.type) {
              case "Refund":
                return "#3b5998";
              case "Refund Against Duplicate":
                return "#f4b400";
              case "Chargeback":
                return "#34a853";
              case "Chargeback Alert":
                return "#6c757d";
              case "Chargeback RDR":
                return "#ff5722";
              default:
                return "#888888";
            }

          })(),
        })),
      },
    ],
    events: {
      render() {
        const chart = this;
        const total = chart.series[0].data.reduce((acc, p) => acc + p.y, 0);
        const labelX = chart.plotWidth / 2 + chart.plotLeft - 25;
        const labelY = chart.plotHeight / 2 + chart.plotTop - 25;

        if (!chart.customLabel) {
          chart.customLabel = chart.renderer
            .label(`Total<br><b>${total}</b>`, labelX, labelY)
            .css({ textAlign: "center", color: "#111827", fontSize: "13px" })
            .add();
        } else {
          chart.customLabel.attr({ text: `Total<br><b>${total}</b>` });
        }
      },
    },
  };

  const changeAllTime = (e) => {
    setAllTime(e);
  };

  const inputRef = useRef();

  const openMonthPicker = () => {
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    } else {
      inputRef.current?.focus();
      inputRef.current?.click();
    }
  };

  const getFilterLabel = () => {
    if (filterType === "all_time") return "All Time";

    if (filterType === "range") {
      const map = {
        last_month: "Last Month",
        this_year: "This Year",
        last_year: "Last Year",
        this_quater: "This Quarter",
      };
      return map[rangeType] || "Select";
    }

    // month
    return moment(selectedMonth, "YYYY-MM").format("MMMM YYYY");
  };

  const hasKpiData =
    Number(kpiData?.cb_won) > 0 ||
    Number(kpiData?.cb_win_rate) > 0 ||
    Number(kpiData?.cb_lost) > 0;

  const handleKpiClick = (type) => {
    const filters = {};

    // Backend always gives start_date & end_date for current selection
    if (stEnDates?.start_date && stEnDates?.end_date) {
      filters.date_range = `${stEnDates.start_date},${stEnDates.end_date}`;
    }

    // Build query manually to keep comma
    let query = `type=${type}`;
    if (filters.date_range) query += `&date_range=${filters.date_range}`;

    // route(`/refunds/organization/refund?${query}`);

    window.open(`/refunds/organization/refund?${query}`, '_blank')

  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    // setSelectedIds([]);
    // getData({});
    // setChangeModal(false);
    setShowRefund(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  return (
    <>
      <div className="pt-[20px] overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          {/* Header */}
          <div className="flex items-center justify-between">
            <TitleHeading>Refunds Overviews</TitleHeading>
            <div className="flex gap-3 flex-shrink-0 w-fit items-center justify-end">
              <div className={Style.bpfl_action}>
                <div
                  className={Style.bpfl_action}
                  onClick={() => {
                    setShowRefund(true);
                  }}
                >
                  <Tooltip
                    content={"Add Refund"}
                    position={"left center"}
                    className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                  >
                    <div className={Style.icon}>
                      <PlusIcon size="1em" />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <FeildWraper className={"!w-fit !flex-[0_0_auto] !pl-0 !py-0"}>
                <div className="relative">
                  <input
                    type="month"
                    ref={inputRef}
                    className="absolute opacity-0 pointer-events-none"
                    max={moment(new Date()).format("YYYY-MM")}
                    value={selectedMonth}
                    onChange={(e) => {
                      setFilterType("month");
                      setRangeType(null);
                      setSelectedMonth(e.target.value);
                    }}
                  />

                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown"
                  >
                    <CustomDropdownButton arrow={false} className="btnClass">
                      <div className="flex items-center gap-2 px-5 py-1">
                        <CalendarIcon size={16} />
                        <h3 className="!text-[16px]">{getFilterLabel()}</h3>
                      </div>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      <CustomDropdownMenuList
                        className={
                          filterType === "all_time" ? "bg-[#f2f2f2]" : ""
                        }
                        onClick={() => {
                          setFilterType("all_time");
                          setRangeType(null);
                        }}
                      >
                        All Time
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        className={
                          rangeType === "last_month" ? "bg-[#f2f2f2]" : ""
                        }
                        onClick={() => {
                          setFilterType("range");
                          setRangeType("last_month");
                        }}
                      >
                        Last Month
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setFilterType("range");
                          setRangeType("this_year");
                        }}
                      >
                        This Year
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setFilterType("range");
                          setRangeType("last_year");
                        }}
                      >
                        Last Year
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setFilterType("range");
                          setRangeType("this_quater");
                        }}
                      >
                        This Quarter
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setFilterType("month");
                          setRangeType(null);
                          openMonthPicker();
                        }}
                      >
                        Custom Month
                      </CustomDropdownMenuList>
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </div>
              </FeildWraper>
            </div>
          </div>

          {/* KPI Row */}

          <TableCard className={"!p-[15px] !pr-[7px] h-full overflow-hidden"}>
            <TitleHeading className={"mb-5"}>
              Refunds & Chargebacks Summary
            </TitleHeading>

            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {isDashboardApiLoaded ? (
                <>
                  <KPI
                    icon={History}
                    label={"Total Lost"}
                    value={kpiData?.total_loss_amount}
                    sublabel={`Revenue lost to disputes`}
                    extraClass={"theme"}
                    stateLable={`${kpiData?.total_loss}`}
                    positive={kpiData?.total_loss > 0}
                    positiveIcon={null}

                  // onClick={() => {
                  //   setPopupData({
                  //     apiKey: "data",
                  //     apiUrl: "reports/department-responsibility",
                  //     pagUrl: "/refunds/organization/report-by-department",
                  //     title: `By Department`,
                  //     subTitle: `Refunds By Department`,
                  //     icon: <CheckCircle />,
                  //     // positive: kpiData?.probation_ending_percentage > 0,
                  //     // stateLable: `${kpiData?.probation_ending_percentage?.toFixed(0)?.replace("-", "")}%`,
                  //   });
                  //   setShowWorkForce(true);
                  // }}
                  />

                  <KPI
                    icon={RotateCcw}
                    label="Total Refunds"
                    value={`${kpiData?.total_refunded_amount}`}
                    sublabel={`Customer-initiated refunds`}
                    extraClass={"red"}
                    stateLable={`${kpiData?.total_refund}`}
                    positive={kpiData?.total_refund > 0}
                    positiveIcon={null}
                    onClick={() => handleKpiClick("all-refunds")}
                  />

                  <KPI
                    icon={DollarSign}
                    label="Total Chargebacks"
                    value={`${kpiData?.total_chargeback_amount}`}
                    sublabel={`Bank-raised payment disputes`}
                    extraClass={"yellow"}
                    stateLable={`${kpiData?.total_charge_backs}`}
                    positive={kpiData?.total_charge_backs > 0}
                    positiveIcon={null}
                    onClick={() => handleKpiClick("all-chargebacks")}
                  />

                  <KPI
                    icon={UserX}
                    label="Sales Blame"
                    value={`${kpiData?.sales_blame_amount}`}
                    sublabel={`Internal sales errors`}
                    stateLable={`${kpiData?.sales_blame_count}`}
                    positive={kpiData?.sales_blame_count > 0}
                    positiveIcon={null}
                  />

                  <KPI
                    icon={CircleDollarSign}
                    label="Customer Blame"
                    value={`${kpiData?.customer_blame_amount}`}
                    sublabel={`Customer-driven disputes`}
                    stateLable={`${kpiData?.customer_blame_count}`}
                    positive={kpiData?.customer_blame_count > 0}
                    positiveIcon={null}
                  />
                </>
              ) : (
                Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="bg-white shadow rounded-xl p-4 animate-pulse"
                  >
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    {/* Value row */}
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    {/* Sublabel */}
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div>

            {hasKpiData && (
              <>
                <TitleHeading className="mb-5 mt-5">
                  Chargeback Win Analysis
                </TitleHeading>

                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                  {isDashboardApiLoaded ? (
                    <>
                      <KPI
                        icon={ShieldCheck}
                        label="Chargebacks Won"
                        value={kpiData?.cb_won}
                        sublabel="Successfully reversed cases"
                        extraClass="green"
                      />

                      <KPI
                        icon={TrendingUp}
                        label="Win Rate"
                        value={kpiData?.cb_win_rate}
                        sublabel="Success percentage overall"
                      />

                      <KPI
                        icon={ShieldX}
                        label="Chargebacks Lost"
                        value={kpiData?.cb_lost}
                        sublabel="Unrecovered dispute losses"
                        extraClass="red"
                      />
                    </>
                  ) : (
                    Array.from({ length: 5 }).map((_, index) => (
                      <div
                        key={index}
                        className="bg-white shadow rounded-xl p-4 animate-pulse"
                      >
                        {/* Skeleton content */}
                      </div>
                    ))
                  )}
                </div>
              </>
            )}

            <div className="grid grid-cols-12 gap-5 mt-5">
              {/* Chart Card */}
              <Card className="col-span-12 lg:col-span-8 max-h-300px">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <TrendingUp className="h-5 w-5" />
                    Loss Revenue
                    {/* <CustomDropdown
                      position="bottom-right"
                      className="myDropdown !w-[250px]"
                    >
                      <CustomDropdownButton
                        arrow={true}
                        className="btnClass !w-[250px] !justify-between"
                      >
                        <h3 className="!text-[16px]">{activeChart}</h3>
                      </CustomDropdownButton>

                      {activeChart !== "Refunded Amount" && (
                        <CustomDropdownMenu className="w-full">
                          <CustomDropdownMenuList onClick={() => setActiveChart("Refunded Amount")}>
                            <div className="d-flex whitespace-normal align-items-center gap-1">
                              Refunded Amount
                            </div>
                          </CustomDropdownMenuList>
                        </CustomDropdownMenu>
                      )}
                    </CustomDropdown> */}
                  </CardTitle>

                  {/* Month Filter */}

                  <div className={`flex items-center filterMonths ${Style.filterMonths}`}>
                    {[6, 12, "all"].map((month) => (
                      <div
                        key={month}
                        className={`${Style.filterMonth} cursor-pointer`}
                        onClick={() => setSelectedMonths(month)}
                      >
                        <div
                          className={`${Style.legendLine} ${selectedMonths === month ? Style.active : ""
                            }`}
                        ></div>
                        <p>{month === "all" ? "All Time" : `${month} Months`}</p>
                      </div>
                    ))}
                  </div>
                </CardHeader>

                <CardContent>
                  {!trendLoading ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={lineOptions}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>


                {/* <CardContent>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={lineOptions}
                  />
                </CardContent> */}
              </Card>

              {/* Pie Chart */}
              <Card className="col-span-12 lg:col-span-4 min-h-[400px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <Paperclip className="h-5 w-5" /> Refund by Type
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {isDashboardApiLoaded ? (
                    sourceData?.length > 0 ? (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={sourceOptions}
                      />
                    ) : (
                      <div className="flex justify-center items-center h-full">
                        <DataNotFound title="Refund" />
                      </div>
                    )
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>
              {/* Refund List Card */}
              <div className="col-span-12 p-5 pb-0 max-h-[550px] min-h-[450px] border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <RefundList data={apiData} isLoading={isDashboardApiLoaded} />
              </div>
            </div>

            {showWorkForce && (
              <KpisPopup
                onClose={() => setShowWorkForce(false)}
                apiKey={popupData?.apiKey}
                apiUrl={popupData?.apiUrl}
                pagUrl={popupData?.pagUrl}
                title={popupData?.title}
                subTitle={popupData?.subTitle}
                icon={popupData?.icon}
                positive={popupData?.positive}
                stateLable={popupData?.stateLable}
                positiveIcon={popupData?.positiveIcon}
              />
            )}
          </TableCard>
        </div>
      </div>
      {showRefund && (
        <RefundForm
          onError={onError}
          onSubmit={onSuccess}
          onClose={() => {
            setShowRefund(false);
            // setCurrentData({});
          }}
        // refundDataId={currentData}
        // brands={brands}
        // agents={agents}
        // brandsProducts={brandsProducts}
        // merchants={merchants}
        // merchantsType={merchantsType}
        // cbOrRefundOptions={cbOrRefundOptions}
        // cbOutcomeOptions={cbOutcomeOptions}
        // departmentOptions={departmentOptions}
        // qaStatusOptions={qaStatusOptions}
        // quarterOptions={quarterOptions}
        // repitchOutcomeOptions={repitchOutcomeOptions}
        // responsibleOptions={responsibleOptions}
        // sourceOptions={sourceOptions}
        // workStatusOptions={workStatusOptions}
        // yearOptions={yearOptions}
        // processorReasonOptions={processorReasonOptions}
        />
      )}
      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
}
